import React from 'react';
import { usePlatformFeatureFlags } from '@components';
import { ProductBoxStatic, useProductBox } from '@fourthwall/module-product';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { useOnceInView, useTagManager } from '@hooks';
import { useCurrentShop } from '../../../../hooks/useCurrentShop';
export const SliderProductBox = ({ product, href, activeCategory, }) => {
    const { isWebView } = useWebViewBridge();
    const tagManager = useTagManager();
    const { hasFeatureFlag } = usePlatformFeatureFlags();
    const { currentShop } = useCurrentShop();
    const ref = useOnceInView(() => tagManager.trigger('recommendation_view', {
        recommendation_type: 'create_new_product',
        flow: 'product',
        product_id: product.id,
        product_name: product.name,
        shop_id: currentShop?.id || '',
        experiment_variant: hasFeatureFlag('dashboard:recommended_products_experiment')
            ? 'ACTIVE'
            : 'NONE',
        active_category: activeCategory,
    }));
    const productBox = useProductBox({ product });
    return (React.createElement("div", { ref: ref },
        React.createElement(ProductBoxStatic, { size: "compact", product: product, href: href, activeProduct: productBox.activeProduct, isWebView: isWebView })));
};
